import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";
import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";
import { PublicInterceptorPR } from "../../../Base/interceptors/PublicInterceptorsPR";



// GET MEMOS POR RANGO DE FECHA
export const getMemos = async (fechas) => {
    return await PrivateInterceptor('Memo/getMemos', 'POST', fechas);
}

// GET UN MEMO
export const getMemo = async (memo) => {
    return await PrivateInterceptor(`Memo/getMemo/${memo}`, 'GET');
}


// GET MEMOALIMENTACION
export const getMemoAlimentacion = async (IdMemo, token) => {
   return await PrivateInterceptor('Memo/getAlimentacionMemo', 'POST', {IdMemo});
}
// GET MEMOALIMENTACION
export const getMemoAlimentacionToken = async (IdMemo, token) => {
    return await PublicInterceptor('Memo/getAlimentacionMemo', 'POST', {IdMemo}, token);
}

export const getMemoToken = async (memo, token) => {
    return await PublicInterceptor(`Memo/getMemo/${memo}`, 'GET', {}, token);
}

export const deleteMemoAlimentacion = async (IdMemoDetalle) => {
    return await PrivateInterceptor('Memo/deleteAlimentacionMemo', 'POST', {IdMemoDetalle});
   
}


// GUARDAR MEMO
export const postMemo = async (memo) => {
    const result = await PrivateInterceptor('Memo/save', 'POST', memo);
    return result;

}

// CHANGE PERMISO MEMO
export const changePermisoMemo = async (data) => {
    const result = await PrivateInterceptor('Memo/changePermiso', 'POST', data);
    return result;
}

// GUARDAR UN ARCHIVO DEL MEMO
export const postArchivoMemo = async (File) => {
    const result = await PrivateInterceptor(`Memo/file`, 'POST', File);
    return result;
}


// OBTENER LOS ARCHIVOS DEL MEMO 
export const getArchivoMemo = async (IdMemo) => {
    const resutl = await PrivateInterceptor(`Memo/getFile`, 'POST', { IdMemo });
    return resutl;
}
// OBTENER LOS ARCHIVOS DEL MEMO 
export const getArchivoMemoToken = async (IdMemo, token) => {
    const resutl = await PublicInterceptor(`Memo/getFile`, 'POST', { IdMemo }, token);
    return resutl;
}


// UPLOAD FILE 
export const uploadFileMemo = async (files) => {
   const result = await PrivateInterceptor('/Memo/upload', 'POST', {files});
   return result; 
}

// DELETE FILE  
export const deleteFileMemo = async (IdImg) => {
   const result = await PrivateInterceptor('/Memo/deleteFile', 'POST', {IdImg});
   return result;
}


// CAMBIAR ESTADO DISTRIBUIDO
export const changeStatusDist = async (IdMemo) => {
    const result = await PrivateInterceptor('/Memo/changeStatus/dist', 'POST', { IdMemo});
    return result;
 }

//  SET ASISTENCIA MEMO

//  OBTENER ASISTENCIA MEMO 
export const getAsistenciaMemo = async (IdMemo) => {
    const result = await PrivateInterceptorsPR(`RH/Memos/Asistencia/${IdMemo}`);
    return result;
}

export const setAsistenciaMemo = async (Memo) => {
    const result = await PrivateInterceptorsPR(`RH/Memos/Asistencia`, 'POST', Memo);
    return result;
}

// CANCELAR UN MEMO
export const cancelarMemoRequest = async (Datos) => {
   const result = await PrivateInterceptor(`Memo/cancelar`, 'POST', {Datos});
   return result;
}

// CHANGE TRANSPORTE DETALLE    
export const changeTransporteDetalle = async(info) => {
   return await PrivateInterceptorsPR('RH/Memos/changeTransporteDetalle', 'POST', info);
}

// GET TRANSPORTE MEMO 
export const getMemoTransporte = async (IdMemo) => {
   return await PrivateInterceptorsPR('RH/Memos/getTransporte', 'POST', {IdMemo});
}

// GET TRANSPORTE MEMO 
export const getMemoTransporteToken = async (IdMemo, token) => {
   return await PublicInterceptorPR('RH/Memos/getTransporte', 'POST', {IdMemo}, token);
}

// BORRAR DETALLE TRANSPORTE MEMO
export const deleteTransporteDetalle = async (IdDetalle) => {
    return await PrivateInterceptorsPR('RH/Memos/deleteTransporteDetalle', 'POST', {IdDetalle});
}

// BORRAR DETALLE TRANSPORTE MEMO
export const deleteTransporteFecha = async (IdDetalleFecha) => {
    return await PrivateInterceptorsPR('RH/Memos/deleteTransporteFecha', 'POST', {IdDetalleFecha});
}